<template>
  <div class="modal-backdrop">
    <div class="modal-panel" :class="panelClass">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";

const modalSizeClasses = {
  sm: "modal-panel--sm",
  md: "modal-panel--md",
  lg: "modal-panel--lg",
  xl: "modal-panel--xl",
};

type ModalSize = keyof typeof modalSizeClasses;

export default defineComponent({
  props: {
    size: {
      type: String as PropType<ModalSize>,
      default: "md",
      validator: (value: string) =>
        Object.prototype.hasOwnProperty.call(modalSizeClasses, value),
    },
  },
  setup(props) {
    const panelClass = computed(() => modalSizeClasses[props.size]);

    return {
      panelClass,
    };
  },
});
</script>
